import ProxyBase from '../../../../core/proxies/ProxyBase'

class DynamicReportProxy extends ProxyBase {
  getTemplates(params) {
    return this.get('Templates', params, undefined, true)
  }
  deleteTemplates(params) {
    return this.delete('Delete', params)
  }
  updateTemplate(params) {
    return this.post('Update', params)
  }
  saveTemplate(params) {
    return this.post('Create', params)
  }
  uploadFileDynamic(params) {
    return this.post('upload', params, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }
}

export default new DynamicReportProxy('DynamicReport/')
